/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Large_Smart_Slug_KickInputs */

const fr_large_smart_slug_kick = /** @type {(inputs: Large_Smart_Slug_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements et abonnements`)
};

/**

* @param {Large_Smart_Slug_KickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const large_smart_slug_kick = /** @type {((inputs?: Large_Smart_Slug_KickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Large_Smart_Slug_KickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_large_smart_slug_kick(inputs)
});